import { useNode } from "@craftjs/core";
import React from "react";
import {
  ColorInput,
  UnitInput,
  MarginInput,
  Tabs,
  Spacer,
  AlignInput,
} from "../../input";
import { supportLibrary } from "../../block-supports";
import { isUpdatedFromDefault } from "../../utils";

export const SeparatorSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    width,
    widthTablet,
    widthMobile,
    color,
    align,
    alignTablet,
    alignMobile,
    layoutMargin,
    layoutMarginTablet,
    layoutMarginMobile,
  } = props;
  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing="1rem">
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={width}
            valueTablet={widthTablet}
            valueMobile={widthMobile}
            onChange={(val) => {
              setProp((props) => {
                props.width = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.widthTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.widthMobile = val;
              });
            }}
            label={"Width"}
          />

          <AlignInput
            isResponsive={true}
            resetValue={undefined}
            value={align}
            valueTablet={alignTablet}
            valueMobile={alignMobile}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.alignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.alignMobile = val;
              });
            }}
            label={"Align"}
          />
        </Spacer>
      </div>
    );
  }

  function StyleSettings() {
    return (
      <>
        <Spacer spacing={"1rem"}>
          <ColorInput
            resetValue={undefined}
            value={color}
            onChange={(val) => {
              setProp((props) => {
                props.color = val;
              });
            }}
            label={"Color"}
          />
        </Spacer>
      </>
    );
  }

  function AdvancedSettings() {
    return (
      <>
        <Spacer spacing={"1rem"}>
          <MarginInput
            isResponsive={true}
            valueTablet={layoutMarginTablet}
            valueMobile={layoutMarginMobile}
            resetValue={undefined}
            value={layoutMargin}
            onChange={(val) => {
              setProp((props) => {
                props.layoutMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.layoutMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.layoutMarginMobile = val;
              });
            }}
            label={"Margin"}
          />
        </Spacer>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: width },
        { key: widthTablet },
        { key: widthMobile },
        { key: align },
        { key: alignTablet },
        { key: alignMobile },
      ]),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
      isUpdated: isUpdatedFromDefault([{ key: color }]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: layoutMarginTablet },
        { key: layoutMarginMobile },
        { key: layoutMargin },
      ]),
    },
  ];

  return (
    <div>
      <Tabs items={tabs} id={`block-settings-tab-${id}`} />
    </div>
  );
};
